import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { LanguageRoutingService } from '../../../services/language-routing.service';
import { AuthService } from '../../../services/auth.service';
import { Job } from '../../../models/job.model';
import { MatchScoreClassPipe } from '../../../../../../../libs/shared/src/lib/pipes/match-score-class.pipe';
import { MatchScoreNormalizedPipe } from '../../../../../../../libs/shared/src/lib/pipes/match-score-normalized.pipe';

@Component({
  selector: 'app-job-apply-hero',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    TranslocoModule,
    MatchScoreClassPipe,
    MatchScoreNormalizedPipe
  ],
  templateUrl: './job-apply-hero.component.html',
  styleUrls: ['./job-apply-hero.component.scss'],
})
export class JobApplyHeroComponent {
  @Input() job: Job | null = null;
  @Input() matchScore: number | null = null;

  constructor(
    private languageRoutingService: LanguageRoutingService,
    private authService: AuthService
  ) {}

  getLocalizedRoute(path: string): string {
    return this.languageRoutingService.getLocalizedRoute(path);
  }

  get isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }
}
